/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var Site = /** @class */ (function () {
        function Site() {
        }
        Site.init = function () {
            new Site().run();
        };
        Site.prototype.run = function () {
            this.boxes();
            Site.initResponsiveVideo();
        };
        Site.prototype.boxes = function () {
            var observerOptions = {
                root: null,
                rootMargin: "0px",
                threshold: 0.1
            };
            function observerCallback(entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('inView', 'entered');
                    }
                    else {
                        entry.target.classList.remove('inView');
                    }
                });
            }
            var observer = new IntersectionObserver(observerCallback, observerOptions);
            var boxes = document.querySelectorAll('main .box');
            boxes.forEach(function (el) { return observer.observe(el); });
        };
        Site.initResponsiveVideo = function () {
            var iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');
            Array.prototype.forEach.call(iframes, function (el) {
                if (el.closest('.embed-responsive')) {
                    return;
                }
                var videoWrapper = document.createElement('div');
                videoWrapper.classList.add('video');
                videoWrapper.style.maxWidth = el.width;
                var responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('embed-responsive', 'embed-responsive-16by9');
                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
                responsiveWrapper.parentNode.insertBefore(videoWrapper, responsiveWrapper);
                videoWrapper.appendChild(responsiveWrapper);
            });
        };
        return Site;
    }());
    Site.init();

    exports.Site = Site;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
